/* istanbul ignore file */

// Declaration
declare global {
  var __env__: {
    ENV: string;
    DIAM_API: string;
    CLIENT_ID: string;
    SENTRY_DSN: string;
  };
}

// Variables
export const environment = globalThis.__env__.ENV;
export const diamApi = globalThis.__env__.DIAM_API;
export const clientId = globalThis.__env__.CLIENT_ID;
export const sentryDsn = globalThis.__env__.SENTRY_DSN;
export const isLocal = environment === 'local';
export const isTest = environment === 'test';
export const isDev = environment === 'dev';

// Handle variables not set
if (!diamApi || !clientId) {
  throw new Error('Missing environment variables, application will not work!');
}
